import { useReducer, useMemo } from 'react';

// Simple spinning state
type SpinState = 'SPINNING' | 'NOT_SPINNING';

// Events that control spinning
type SpinEvent = 
  | { type: 'START_SPINNING' }
  | { type: 'STOP_SPINNING' };

// Initial state - not spinning
const initialState: SpinState = 'NOT_SPINNING';

// Simple reducer for spin state
function spinReducer(state: SpinState, event: SpinEvent): SpinState {
  switch (event.type) {
    case 'START_SPINNING':
      return 'SPINNING';
    case 'STOP_SPINNING':
      return 'NOT_SPINNING';
    default:
      return state;
  }
}

export function useBowtieSpin() {
  const [state, dispatch] = useReducer(spinReducer, initialState);

  const spinApi = useMemo(() => ({
    // Actions
    startSpinning: () => dispatch({ type: 'START_SPINNING' }),
    stopSpinning: () => dispatch({ type: 'STOP_SPINNING' }),
    
    // State accessors
    isSpinning: state === 'SPINNING',
  }), [state]);

  return spinApi;
}